module.exports = __webpack_public_path__ + "img/paypal.9e6562e2.svg";